/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const invoiceSummaryBucketDataSchema = z.object({
	count: z.number(),
	amount: z.number(),
	currency: z.string(),
})

export type InvoiceSummaryBucketDataSchema = z.infer<typeof invoiceSummaryBucketDataSchema>
